<div class="flex flex-col gap-xs px-md py-lg">
  <span class="body-md text-content-text-body-secondary" [class.invisible]="compactView">Optionen</span>
  <ng-container
    *ngTemplateOutlet="sidebarButton; context: {icon: 'restart_alt', buttonText: 'Chat neu starten', triggered: restart.bind(this), disabled: !store.messageCount()}"></ng-container>
  <ng-container
    *ngTemplateOutlet="sidebarButton; context: {icon: 'settings', buttonText: 'Einstellungen', triggered: openSettings.bind(this), disabled: false}"></ng-container>
  <ng-container
    *ngTemplateOutlet="sidebarButton; context: {icon: 'contact_support', buttonText: 'Technischer Support', buttonClasses: 'text-nowrap', iconRight: 'open_in_new', triggered: openSupport, disabled: false}"></ng-container>
<!--  <ng-container-->
<!--    *ngTemplateOutlet="sidebarButton; context: {icon: 'info', buttonText: 'Mehr zum Chatbot',  iconRight: 'open_in_new', triggered: null, disabled: false}"></ng-container>-->
</div>


<ng-template #sidebarButton
             let-icon="icon"
             let-iconRight="iconRight"
             let-buttonText="buttonText"
             let-triggered="triggered"
             let-disabled="disabled"
             let-buttonClasses="buttonClasses"
>
  @if (!compactView) {
    <core-button [buttonClasses]="'w-full ' + (buttonClasses ? buttonClasses : '')"
                 btnStyle="ghost"
                 [iconLeft]="icon"
                 [iconRight]="iconRight"
                 (triggered)="triggered()"
                 [disabled]="disabled"
                 size="sm">
      {{ buttonText }}
    </core-button>
  } @else {
    <core-icon-button btnStyle="ghost" [icon]="icon" (triggered)="triggered()" [disabled]="disabled" size="sm"
                      [tooltip]="buttonText" placement="right" />
  }
</ng-template>

